import { cn } from '@/lib/utils.js';

export type StatusState = 'up' | 'degraded' | 'down' | 'unknown';

const COLORS: Record<StatusState, string> = {
  up: 'bg-status-up shadow-[0_0_0_3px_hsl(var(--status-up)/0.2)]',
  degraded: 'bg-status-degraded shadow-[0_0_0_3px_hsl(var(--status-degraded)/0.2)]',
  down: 'bg-status-down shadow-[0_0_0_3px_hsl(var(--status-down)/0.2)]',
  unknown: 'bg-status-unknown shadow-[0_0_0_3px_hsl(var(--status-unknown)/0.2)]',
};

const LABELS: Record<StatusState, string> = {
  up: 'Up',
  degraded: 'Degraded',
  down: 'Down',
  unknown: 'Unknown',
};

export function StatusDot({
  state,
  showLabel = false,
  className,
}: {
  state: StatusState;
  showLabel?: boolean;
  className?: string;
}): JSX.Element {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span className={cn('inline-block h-2.5 w-2.5 rounded-full', COLORS[state])} />
      {showLabel && <span className="text-xs text-muted-foreground">{LABELS[state]}</span>}
    </span>
  );
}
